;(function($){

    function Tickets() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });


        
        if($("#modal-priority").length > 0) {

            $("#modal-priority").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();   
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();
                    var baixa = '';
                    var media = '';
                    var alta = '';
                    var urgente = '';
                    var critica = '';
                    if(_.priority == 1)
                    {
                        baixa = 'selected';
                    }else {
                        baixa = '';
                    }
                    if(_.priority == 2)
                    {

                        media = 'selected';
                    }else {
                        media = '';
                    
                    }
                    if(_.priority == 3)
                    {
                        alta = 'selected';
                        
                    }else {
                        alta = '';
                     }
                    if(_.priority == 4)
                    {
                        urgente = 'selected';
                        
                    }else {
                        urgente = '';
                    
                    }
                    if(_.priority == 5)
                    {
                        critica = 'selected';
                       
                    }else {
                        critica = '';
                    }

                    _.html = '<form id="form-priority" enctype="multipart/form-data">'+
                   '<div class="row">' +  
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="priority_id">Prioridade</label>' +
                                '<select id="priority_id" name="priority_id">' +
                                '<option value="1" '+ baixa +'>Baixa</option>' +
                                '<option value="2" '+ media +'>Média</option>' +
                                '<option value="3" '+ alta +'>Alta</option>' +
                                '<option value="4" '+ urgente +'>Urgente</option>' +
                                '<option value="5" '+ critica +'>Crítica</option>' +
                                '</select">' +
                            '</div>'+
                        '</div>'+        
                       '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12" >'+
                           '<div class="form-row" style="margin-top:10px"><br/>' +
                               '<input type="hidden" id="tickets_id" name="tickets_id" value="'+_.tickets_id+'">' +
                               '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                           '</div>'+
                       '</div>'+                                
                   '</div></form>';

                    if(_.html != ""){
                    $('#modal-priority').iziModal('setTitle', 'Alterar a prioridade');
                    $("#modal-priority .content").html(_.html);

                    _.myForm = $("#form-priority").validate({
                        rules: {
                            priority_id: { required: true }, 
                        },
                        messages: {
                            priority_id: { required: "Campo Obrigatório" }, 
                        },
                        invalidHandler: function(e) {
                            swal({
                                title: "Atenção!",
                                text: "Preencha todos os campos.",
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "OK!",
                                closeOnConfirm: true
                            });

                        },
                        submitHandler: function( form ) {
                        
                             
                            
                            $("#form-priority .btn-send").html("Enviando...");
                            $.ajax({
                                type: "POST",
                                url: _.API + "tickets/" + _.tickets_id + "/atualizar-prioridade",
                                cache: false,
                                contentType: false,
                                processData: false,
                                data: new FormData(form),
                                success: function(result)
                                {
                                    $("#form-priority .btn-send").html("Enviar");

                                    form.reset();

                                    $('#modal-priority').iziModal('close'); 

                                    swal({
                                        title: result.message,
                                        text: "Click no botão para fechar!",
                                        type: "success",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: false
                                    }).then(function() {
                                      location = location+"#documentos";

                                      location.reload(true);
                                    });                                        
                                },
                                error: function(response) {
                                    var errors = $.parseJSON(response.responseText);
                                    
                                    swal({
                                        title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                        text: "Click no botão para fechar!",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: true
                                    });

                                   
                                    $myForm.showErrors(errors);
                                    
                                    $("#form-priority .btn-send").html("Enviar");
                                }
                            });
                        }
                    });
                }                
                },
                onClosed: function() {
                    _.uri          = null;
                    _.tickets_id = null;
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-priority .content").html("");
                    $('#modal-priority').iziModal('setTitle', "");
                }        
            });
        } 

        $('button.btn-update-priority').on("click", function(e){
       
            e.preventDefault();
            _.tickets_id   = $(this).data('ticket');
            _.priority   = $(this).data('priority'); 
            
            $("select#priority").attr('disabled', false);
            $('#modal-priority').iziModal('open');     
        }); 

         
    }

    
         

   	new Tickets();

}(jQuery));